module.exports = __webpack_public_path__ + "static/0033-c229c6508e6b9e01e80842fc7bcac36c.png";